import { useLayoutContext } from "@context/layout";
import ArrowLeft2Icon from "@svg/new-design/arrow-left2";
import { stringifiedFarsiNum } from "@utils/digits";
import SubscriptionShineIcon from "@svg/new-design/SubscriptionShineIcon";
import Link from "next/link";
import { FC, useMemo } from "react";

const ProgramSubscriptiuonBanner: FC = () => {
  const { staticData, subscriptionData } = useLayoutContext();

  const hasSubscription = Boolean(subscriptionData?.is_active);
  if (hasSubscription) return null;

  const formattedCountLabel = useMemo(
    () =>
      stringifiedFarsiNum(staticData?.statistics?.countOfProducts ?? 0, 17_000),
    [staticData?.statistics?.countOfProducts]
  );

  return (
    <Link
      target="_blank"
      href="/subscription"
      prefetch={false}
      passHref
      className="flex w-full relative rounded-8 h-10 subscription-gradient-border"
    >
      <div className="items-center product-banner-bg rounded-[7px] px-3 flex w-full relative justify-between">
        <div className="flex items-center">
          <SubscriptionShineIcon
            width={24}
            height={24}
            role="img"
            aria-label="Faradars subscription"
          />
          <p className="headline-xxsm mr-1.5">
            دسترسی به همه {formattedCountLabel}+ آموزش، با یک اشتراک
          </p>
        </div>
        <ArrowLeft2Icon className="w-5 h-5 text-fds-icon-secondary" />
      </div>
    </Link>
  );
};

export default ProgramSubscriptiuonBanner;
